import React, {useMemo} from "react";
import {useTranslation} from "react-i18next";
// local
import {
  IconStandPhone,
  IconMailLetter,
  IconLicense,
  IconTags,
  IconBriefcase,
} from "components/icons";
import {Tag} from "components/Tag";
import {InitialsBadge} from "components/InitialsBadge";
import {getFullName} from "helpers/helper";
import {color} from "constants/color.consts";
import cn from "classnames";

const ContactCard = ({
  contact,
  maxWidthFitContent,
  blackContent,
  currentUser,
  selectedRegion,
  isActive,
  onClick,
  addClass,
}) => {
  const {t} = useTranslation();

  const contactPhone = useMemo(
    () => contact?.phone ?? contact?.mobilePhone ?? contact.User?.mobilePhone,
    [contact]
  );
  const contactEmail = useMemo(() => contact?.email ?? contact.User?.email, [contact]);
  const iconColor = useMemo(
    () => (blackContent ? color.black : color.darkGray),
    [blackContent]
  );
  const regions = useMemo(() => contact?.rftsProjectAvailableIn, [contact]);

  //TODO Temporary hided. Return after enabling regions (12.06)
  // const hasRegions = useMemo(() => !!regions?.length, [regions]);
  const hasRegions = false;

  const contactsUsersCurrentUser = useMemo(
    () => contact?.OurOrganizationUsers?.find((user) => user?.id === currentUser?.id),
    [contact, currentUser]
  );
  const hasCurrentUser = useMemo(
    () => !!contactsUsersCurrentUser,
    [contactsUsersCurrentUser]
  );
  const initialsBadgeUser = useMemo(
    () =>
      hasCurrentUser ? contactsUsersCurrentUser : contact?.OurOrganizationUsers?.[0],
    [hasCurrentUser, contactsUsersCurrentUser, contact?.OurOrganizationUsers]
  );
  const ourOrganizationUsersCounter = useMemo(
    () =>
      contact?.OurOrganizationUsers?.length > 1
        ? contact?.OurOrganizationUsers?.length - 1
        : null,
    [contact?.OurOrganizationUsers?.length]
  );

  return (
    <div
      className={cn("contact-person_item", {
        "__fit-content": !!maxWidthFitContent,
        "__black-text": !!blackContent,
        [addClass]: !!addClass,
      })}
      onClick={() => onClick && onClick(contact.UserId)}
    >
      <div className="contact-person_item__name">
        <InitialsBadge
          firstName={contact.User?.firstName}
          lastName={contact.User?.lastName}
          addClass="mr-2"
        />
        <span>{getFullName(contact.User?.firstName, contact.User?.lastName)}</span>
      </div>

      {contactEmail && (
        <div className="contact-person_item__mail">
          <IconMailLetter color={iconColor} />
          <span>{contactEmail}</span>
        </div>
      )}
      {contactPhone && (
        <div className="contact-person_item__phone">
          <IconStandPhone color={iconColor} />
          <span>{contactPhone}</span>
        </div>
      )}
      {isActive && contact.position && (
        <div className="contact-person_item__work-kinds">
          <IconLicense color={iconColor} />
          <span>{contact.position}</span>
        </div>
      )}
      {isActive && contact.workKinds && (
        <div className="contact-person_item__work-kinds">
          <IconTags color={iconColor} />
          <span>{contact.workKinds}</span>
        </div>
      )}
      {!isActive && (hasRegions || initialsBadgeUser) && (
        <div className="contact-person_item__work-info">
          {hasRegions && <IconBriefcase color={iconColor} />}
          {hasRegions && (
            <Tag
              text={t(selectedRegion ?? regions[0])}
              color={color.green}
              bold
              noBackground
              miniSelectView
            />
          )}

          {hasRegions && regions?.length > 1 && (
            <span className="ml-1 fz-10">{`+${regions.length - 1}`}</span>
          )}
          {initialsBadgeUser && (
            <InitialsBadge
              firstName={initialsBadgeUser?.firstName}
              lastName={initialsBadgeUser?.lastName}
              isCurrentUser={hasCurrentUser}
              counter={ourOrganizationUsersCounter}
              addClass="mla"
            />
          )}
        </div>
      )}
    </div>
  );
};

export default ContactCard;
